var ResourceLoader = require("./resource-loader");
require('./share');
$(function () {
    var resources = [
        {type: 'img', src: 'images/loading_bg.png'},
        {type: 'img', src: 'images/loading_bi.png'},
        {type: 'img', src: 'images/css_sprites.png'},
        {type: 'img', src: 'images/icon.png'},
        {type: 'img', src: 'images/red-font.png'},
        {type: 'img', src: 'images/top-logo.png'},
        {type: 'img', src: 'images/b-spot.png'},
        {type: 'img', src: 'images/s-spot.png'},
        {type: 'img', src: 'images/circle.png'},
        {type: 'img', src: 'images/corner.png'},
        {type: 'img', src: 'images/get-btn.png'},
        {type: 'img', src: 'images/popup1.png'},
        {type: 'img', src: 'images/popup2.png'},
        {type: 'img', src: 'images/popup3.png'},
        {type: 'img', src: 'images/popup4.png'},
        {type: 'img', src: 'images/share-icon.png'},
        {type: 'img', src: 'images/tips1.png'},
        {type: 'img', src: 'images/tips2.png'},
        {type: 'img', src: 'images/tips3.png'},
        {type: 'img', src: 'images/tips4.png'},
    ];
    var loader = new ResourceLoader(resources);
    loader.onResourceReady = function () {
        var curProcess = parseInt((this.finished / this.resources.length) * 100) + "%";
        $('.loading2').css("height", curProcess);
        $('.video-w video')[0].load();
    };
    loader.load();
    $('.video-w video').bind('canplaythrough', function () {
        $('.video-w video')[0].play();
        $('.loading').remove();
        $('.video-box,.content').show();
        $('.get-btn').delay(1000).fadeIn();
        $('.footer,.sign').delay(2000).fadeIn();
    });

    $('.tips').on("click", function () {
        var index = $(this).parent().index();
        $('.popup').show();
        $('.prop-popup').eq(index).show().siblings().hide();
    });
    $('.popup').on("click", function () {
        $('.popup,.prop-popup').hide();
    })

});



//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 0
// module chunks = 0